import React, { useCallback, useEffect, useState } from "react";

import { getAllPayments } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Message, Row } from "components";

export const PastPaymentList = () => {
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllPayments = useCallback(() => {
    getAllPayments({
      signal,
    })
      .then((res) => {
        setPayments(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const openItem = (item) => {
    goTo(null, null, `${process.env.REACT_APP_FARM_URL}/credit-note/${item.token}`, true);

    if (item.date?.includes("2025")) {
      return Message({ content: "These credit notes are not the official 2025 invoices, only use them for testing", icon: "gremlin" });
    }
  };

  useEffect(() => {
    loadAllPayments();
  }, [loadAllPayments]);

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead headline={`${payments.length} payment records`} description="View past recorded payments here" />
      <Row>
        <Col>
          <AdminTable
            dataSource={payments}
            config={{
              exclude: ["utc", "farmId", "updated", "token"],
              actions: [
                {
                  icon: "tabler/download",
                  func: openItem,
                  tooltip: "Download this file",
                },
                {
                  icon: "tabler/eye",
                  route: "/farm/",
                  record: "farmId",
                  tooltip: "View this farm",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
